// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Afxr","empty":"ModalGraph_empty__PfdAz"};